import type { FilterConfig } from '#types/config/components/filter'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    base: 'b-0 rounded-full',
    selected: 'bg-black c-white',
  }
} satisfies RecursivePartial<FilterConfig['option']['tileExpanded']>
